/**
 * Paging-Cursor zwischen data und API (Opus-Anfrage 13). Opak (base64url), an Mandant
 * und Filter gebunden, enthält nur Sortbestandteile. PK und GSI-PK leitet data immer
 * aus dem geprüften Pfad-Mandanten ab, nie aus dem Cursor.
 */
import { z } from 'zod';
import { TenantId } from './entities.js';

export const CursorPayload = z.object({
  v: z.literal(1),
  tenantId: TenantId,
  /** Hash der Filterparameter, damit ein Cursor nicht mit anderem Filter weiterläuft. */
  filterHash: z.string().regex(/^[a-f0-9]{16,64}$/),
  /** Letzter Sortschlüssel (SK oder GSI-SK), opak für den Client. */
  lastSortKey: z.string().min(1).max(512),
  lastPartitionKey: z.string().min(1).max(256).optional(),
});
export type CursorPayload = z.infer<typeof CursorPayload>;

export class InvalidCursorError extends Error {
  constructor() { super('invalid cursor'); this.name = 'InvalidCursorError'; }
}

export function encodeCursor(payload: CursorPayload): string {
  return Buffer.from(JSON.stringify(CursorPayload.parse(payload)), 'utf8').toString('base64url');
}

/** Wirft InvalidCursorError bei fremdem Mandanten, anderem Filter oder beschädigtem Cursor. */
export function decodeCursor(cursor: string, expected: { tenantId: string; filterHash: string }): CursorPayload {
  if (cursor.length > 2048 || !/^[A-Za-z0-9_-]+$/.test(cursor)) throw new InvalidCursorError();
  let parsed: unknown;
  try { parsed = JSON.parse(Buffer.from(cursor, 'base64url').toString('utf8')); } catch { throw new InvalidCursorError(); }
  const result = CursorPayload.safeParse(parsed);
  if (!result.success || result.data.tenantId !== expected.tenantId || result.data.filterHash !== expected.filterHash) throw new InvalidCursorError();
  return result.data;
}
